import { FormArray, FormGroup } from "@angular/forms";
import {
  BmExpFg,
  BmExpGroupFg,
  BmInvestmentFg,
  BmMgmFeeFg,
  BmMgmFeeGroupForm, BmModelDataFg,
  BudgetModelFormGroup,
} from "../../../pojo/bm-form";
import { BmExpensesCalcService } from "../../expenses/bm-expenses-calc.service";
import { BmSubscriptionsMgmFeeHelperService } from "./bm-subscriptions-mgm-fee-helper.service";
import { BmSubscriptionsExpensesHelperService } from "./bm-subscriptions-expenses-helper.service";
import { BmSubscriptionsInvestmentHelperService } from "./bm-subscriptions-investment-helper.service";
import { BmTotalGeneralCalcService } from "../../total/general/BmTotalGeneralCalcService";
import { BmTotalAccumulatedCapCalcService } from "../../total/accumulated/bm-total-accumulated-cap-calc.service";


export class BmSubscriptionsService {

  public static subscribeOnTotalCommitmentChanges(budgetForm: BudgetModelFormGroup): void {
    budgetForm.controls.totalCommitment.valueChanges.subscribe(() => {
      BmTotalGeneralCalcService.recalculateTotalExpenses(budgetForm, budgetForm.controls.modelData.controls.totalExpenses, false);
      BmSubscriptionsInvestmentHelperService.recalculateInvestmentValue(budgetForm);
      BmTotalGeneralCalcService.recalculateTotalExpenses(budgetForm, budgetForm.controls.modelData.controls.totalCapRequired, true);
      BmTotalGeneralCalcService.recalculateAllRowValuePcnt(budgetForm);
      BmTotalAccumulatedCapCalcService.recalculateTotalAccumulatedRequired(budgetForm);
    });
  }

  public static subscribeOnSectionChanges(budgetForm: BudgetModelFormGroup): void {

    const mgmFeeForm = budgetForm.controls.modelData.controls.mgmFee;
    const opExpForm = budgetForm.controls.modelData.controls.operatingExpenses;
    const orgExpForm = budgetForm.controls.modelData.controls.organizationalExpenses;
    const invForm = budgetForm.controls.modelData.controls.investment;


    mgmFeeForm.controls.groups.controls.forEach((mgmFeeGroup) => {
      this.subscribeToMgmFeeGroup(mgmFeeGroup);
    });

    opExpForm.controls.groups.controls.forEach((groupFG) => {
      this.subscribeToOpExpGroup(groupFG);
    });

    orgExpForm.controls.groups.controls.forEach((groupFG) => {
      this.subscribeToOrgExpGroup(groupFG);
    });

    this.subscribeToInvestmentGroup(invForm, budgetForm);
  }

  /**
   * MANAGEMENT FEE GROUP
   */
  public static subscribeToMgmFeeGroup(mgmFeeGroup: FormGroup<BmMgmFeeGroupForm>): void {
    const mgmFeeGroupsArray = mgmFeeGroup.parent as FormArray<FormGroup<BmMgmFeeGroupForm>>;
    const mgmFee = mgmFeeGroupsArray.parent as FormGroup<BmMgmFeeFg>;
    const modelData = mgmFee.parent as FormGroup<BmModelDataFg>;
    const budgetForm = modelData.parent as BudgetModelFormGroup;

    BmSubscriptionsMgmFeeHelperService.subscribeToMgmCommitment(mgmFeeGroup.controls.subGroups.controls.commitment, mgmFeeGroup, mgmFee, budgetForm);
    BmSubscriptionsMgmFeeHelperService.subscribeToMgmFeePcnt(mgmFeeGroup.controls.subGroups.controls.mgmFeesPcnt, mgmFeeGroup, mgmFee, budgetForm);
    BmSubscriptionsMgmFeeHelperService.subscribeToPcntOfMgmFee(mgmFeeGroup.controls.subGroups.controls.pcntOfMgmFees, mgmFeeGroup, mgmFee, budgetForm);
    BmSubscriptionsMgmFeeHelperService.subscribeToCatchUp(mgmFeeGroup.controls.subGroups.controls.catchUp, mgmFeeGroup, mgmFee, budgetForm);
    BmSubscriptionsMgmFeeHelperService.subscribeToVat(mgmFeeGroup.controls.subGroups.controls.vatPcnt, mgmFeeGroup, mgmFee, budgetForm);
  }

  /**
   * OPERATING EXPENSES GROUP
   */
  public static subscribeToOpExpGroup(opExpGroupFg: FormGroup<BmExpGroupFg>): void {
    const subGroupDataFA = opExpGroupFg.controls.items;

    const opExpGroupFA = opExpGroupFg.parent as FormArray<FormGroup<BmExpGroupFg>>;
    const opExpForm = opExpGroupFA.parent as FormGroup<BmExpFg>;
    const modelData = opExpForm.parent as FormGroup<BmModelDataFg>;
    const budgetForm = modelData.parent as BudgetModelFormGroup;

    opExpGroupFg.controls.dataFillingType.valueChanges.subscribe(() => {
      BmSubscriptionsExpensesHelperService.recalculateRelatedValues(opExpGroupFg, opExpForm, budgetForm);
    });

    opExpGroupFg.controls.standardValue.valueChanges.subscribe(() => {
      BmSubscriptionsExpensesHelperService.recalculateRelatedValues(opExpGroupFg, opExpForm, budgetForm);
    });

    subGroupDataFA.valueChanges.subscribe(() => {
      BmExpensesCalcService.handleItemsChange(opExpGroupFg);
      BmSubscriptionsExpensesHelperService.recalculateRelatedValues(opExpGroupFg, opExpForm, budgetForm);
    });
  }

  /**
   * ORGANIZATIONAL EXPENSES GROUP
   */
  public static subscribeToOrgExpGroup(orgExpGroupFg: FormGroup<BmExpGroupFg>): void {
    const dataFillingTypeCtrl = orgExpGroupFg.controls.dataFillingType;
    const standardValueCtrl = orgExpGroupFg.controls.standardValue;
    const subGroupDataFA = orgExpGroupFg.controls.items;

    const orgExpGroupFA = orgExpGroupFg.parent as FormArray<FormGroup<BmExpGroupFg>>;
    const orgExpForm = orgExpGroupFA.parent as FormGroup<BmExpFg>;
    const modelData = orgExpForm.parent as FormGroup<BmModelDataFg>;
    const budgetForm = modelData.parent as BudgetModelFormGroup;

    dataFillingTypeCtrl.valueChanges.subscribe(() => {
      BmSubscriptionsExpensesHelperService.recalculateRelatedValues(orgExpGroupFg, orgExpForm, budgetForm);
    });

    standardValueCtrl.valueChanges.subscribe(() => {
      BmSubscriptionsExpensesHelperService.recalculateRelatedValues(orgExpGroupFg, orgExpForm, budgetForm);
    });

    subGroupDataFA.valueChanges.subscribe(() => {
      BmExpensesCalcService.handleItemsChange(orgExpGroupFg);
      BmSubscriptionsExpensesHelperService.recalculateRelatedValues(orgExpGroupFg, orgExpForm, budgetForm);
    });
  }

  /**
   * INVESTMENT GROUP
   */
  public static subscribeToInvestmentGroup(invFG: FormGroup<BmInvestmentFg>, budgetForm: BudgetModelFormGroup): void {
    BmSubscriptionsInvestmentHelperService.subscribeToInvestment(invFG, budgetForm);
    BmSubscriptionsInvestmentHelperService.subscribeToItemsPcnt(invFG, budgetForm);
    BmSubscriptionsInvestmentHelperService.subscribeToItemsValue(invFG, budgetForm);
  }
}
